var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.61602 2.677L1.14602 8.146C1.09081 8.20228 1.04969 8.27081 1.02602 8.346L0.0260168 11.346C0.00177141 11.4209 -0.00444925 11.5005 0.00786106 11.5782C0.0201714 11.6559 0.0506648 11.7297 0.0968597 11.7934C0.143055 11.8572 0.203646 11.9091 0.273702 11.945C0.343758 11.9809 0.4213 11.9997 0.500017 12C0.553768 12.0002 0.607177 11.9915 0.658017 11.974L3.65802 10.974C3.73321 10.9503 3.80174 10.9092 3.85802 10.854L9.32702 5.384L6.61602 2.677Z",
    fill: "#797B80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.854 2.14601L9.854 0.146009C9.80756 0.0994455 9.75238 0.0625027 9.69164 0.0372962C9.63089 0.0120898 9.56577 -0.00088501 9.5 -0.00088501C9.43423 -0.00088501 9.36911 0.0120898 9.30837 0.0372962C9.24762 0.0625027 9.19245 0.0994455 9.146 0.146009L7.677 1.61601L10.384 4.32301L11.854 2.85401C11.9006 2.80756 11.9375 2.75239 11.9627 2.69164C11.9879 2.6309 12.0009 2.56578 12.0009 2.50001C12.0009 2.43424 11.9879 2.36912 11.9627 2.30838C11.9375 2.24763 11.9006 2.19245 11.854 2.14601Z",
    fill: "#797B80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ce8d85f7436c810e597a8b26a35d9076.svg";
export { ForwardRef as ReactComponent };